import { Injectable } from '@angular/core';
import { ApiBaseOptions, ApiPostOptions, ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ClinicPayload, CouponsPayload, PatientPayload, Plan, PlansPayload } from '../common.interface';
import { map } from 'rxjs/operators';
import { IMAGE_PLACEHOLDER_PATH } from '../common.constants';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  constructor(private apiService: ApiService) {
  }

  getPlanInfo(id: string, showLoader: boolean): Observable<Plan> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.plan + id + '/',
      withSpinner: showLoader,
    };

    return this.apiService.get(options);
  }

  getAll(): Observable<PlansPayload> {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.plan,
      withSpinner: true,
    };

    return this.apiService.get(options);
  }

  create(data: Plan): Observable<any>  {
    const options: ApiPostOptions = {
      url: environment.apiUrls.plan,
      withSpinner: true,
      body: {
        ...data,
      },
    };
    return this.apiService.post(options);
  }

  update(id: string, data: Plan): Observable<any>  {
    const options: ApiPostOptions = {
      url: environment.apiUrls.plan + (id ? `${id}/` : ''),
      withSpinner: true,
      body: {
        ...data,
      },
    };
    return this.apiService.patch(options);
  }

  delete(id: string): Observable<any>  {
    const options: ApiBaseOptions = {
      url: environment.apiUrls.plan + id + '/',
      withSpinner: true,
    };
    return this.apiService.delete(options);
  }
}
